import { HttpErrorResponse } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { ErrorModel, HttpErrorModel } from '@spartacus/core';

/**
 * В новых сервисах ошибки приходят в новом формате, отличающемся от формата ошибок хайбриса.
 * Данный нормалайзер приводит ошибки хайбриса и новых сервисов к единому виду.
 */

export function normalizeHttpError(error: HttpErrorResponse | any): HttpErrorModel | undefined {
  if (error instanceof HttpErrorResponse) {
    const normalizedError = new HttpErrorModel();
    normalizedError.message = error.message;
    normalizedError.status = error.status;
    normalizedError.statusText = error.statusText;
    normalizedError.url = error.url;
    normalizedError.details = extractErrorDetails(error);

    return normalizedError;
  }

  if (isDevMode()) {
    console.error('Error passed to normalizeHttpError is not HttpErrorResponse instance', error);
  }

  return undefined;
}

function extractErrorDetails(error: HttpErrorResponse): ErrorModel[] {
  if (typeof error.error.error === 'string') {
    return [
      {
        type: error.error.error,
        message: error.error.error_description,
      },
    ];
  }

  if (Array.isArray(error.error.errors)) {
    return error.error.errors;
  }

  // новый формат ошибок СД
  if (Array.isArray(error.error.error.errors)) {
    return error.error.error.errors;
  }

  return [];
}
